module.exports = __webpack_public_path__ + "static/media/Golden_Medal_Icon.2bfcf048.svg";